/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 M stock, use 25 mL in 500 mL final: C2 = (0.5 M × 25 mL) / 500 mL = 0.025 M.`)
};

const es_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock de 0.5 M, usa 25 mL en 500 mL finales: C2 = (0.5 M × 25 mL) / 500 mL = 0.025 M.`)
};

const de_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 M Stammlösung, 25 mL in 500 mL Endvolumen: C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const nl_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,5 M stock, gebruik 25 mL in 500 mL eindvolume: C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const fr_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution mère à 0,5 M, utiliser 25 mL dans 500 mL final : C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const it_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soluzione madre 0,5 M, usa 25 mL in 500 mL finali: C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const pt_br2_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estoque 0,5 M, usar 25 mL em 500 mL finais: C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const pt_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução-mãe 0,5 M, usar 25 mL num final de 500 mL: C2 = (0,5 M × 25 mL) / 500 mL = 0,025 M.`)
};

const ja_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 M ストックから25 mLを最終500 mLに使用: C2 = (0.5 M × 25 mL) / 500 mL = 0.025 M。`)
};

const zh_soldil_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.5 M 母液，取 25 mL 定容至 500 mL：C2 = (0.5 M × 25 mL) / 500 mL = 0.025 M。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_ex2", locale)
	if (locale === "en") return en_soldil_ex2(inputs)
	if (locale === "es") return es_soldil_ex2(inputs)
	if (locale === "de") return de_soldil_ex2(inputs)
	if (locale === "nl") return nl_soldil_ex2(inputs)
	if (locale === "fr") return fr_soldil_ex2(inputs)
	if (locale === "it") return it_soldil_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_ex2(inputs)
	if (locale === "pt") return pt_soldil_ex2(inputs)
	if (locale === "ja") return ja_soldil_ex2(inputs)
	return zh_soldil_ex2(inputs)
};